import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { catchError, throwError } from 'rxjs';

/**
 * HTTP interceptor that handles authentication errors globally.
 * Automatically logs out the user when a 401 Unauthorized response is received.
 */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle 401 Unauthorized - token expired or invalid
      if (error.status === 401) {
        // Check if it's not a login request (don't logout on failed login)
        const isLoginRequest = req.url.includes('/users/login');
        if (!isLoginRequest && auth.isLoggedIn) {
          auth.logout();
        }
      }
      return throwError(() => error);
    })
  );
};
